export const stages = {
  UNINITIALIZATED: 'UNINITIALIZATED',
  BOOTSTRAPPING: 'BOOTSTRAPPING',
  INITIALIZED: 'INITIALIZED',
  FAILED: 'FAILED'
}

export const authTokens = {
  NEWSLETTER_TOKEN: 't',
  EMAIL_TOKEN_V1: 'at',
  EMAIL_TOKEN_V2: 'access_token',
  REGISTRATION_TOKEN: 'registration_token',
  INTERNAL_TOKEN: 'it',
  LOGOUT_KEY: 'logout'
}
